import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { getUnreadCount, type UnreadCountResponse } from '@/api/notification'

export const useNotificationStore = defineStore('notification', () => {
  // State
  const unreadCount = ref(0)
  const isLoading = ref(false)

  // Getters
  const hasUnread = computed(() => unreadCount.value > 0)

  // Actions
  const fetchUnreadCount = async () => {
    try {
      isLoading.value = true
      const res = await getUnreadCount()
      if (res.data.code === 0) {
        unreadCount.value = res.data.data.count
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error)
    } finally {
      isLoading.value = false
    }
  }

  const incrementUnread = () => {
    unreadCount.value++
  }

  const decrementUnread = () => {
    if (unreadCount.value > 0) {
      unreadCount.value--
    }
  }

  const clearUnread = () => {
    unreadCount.value = 0
  }

  return {
    unreadCount,
    isLoading,
    hasUnread,
    fetchUnreadCount,
    incrementUnread,
    decrementUnread,
    clearUnread
  }
})
